import React from 'react';
import { Link } from 'react-router-dom';

const styles = {
  header: {
    padding: '28px 0 18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '18px',
  },
  logo: {
    fontFamily: 'var(--font-display)',
    fontSize: '24px',
    fontWeight: 700,
    color: 'var(--accent)',
    letterSpacing: '-0.03em',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  logoImg: {
    height: '32px',
    width: 'auto',
    objectFit: 'contain',
  },
  logoTag: {
    fontSize: '10px',
    fontFamily: 'var(--font-mono)',
    fontWeight: 500,
    color: 'var(--text-muted)',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    background: 'var(--surface2)',
    border: '1px solid var(--border)',
    borderRadius: '999px',
    padding: '4px 10px',
    marginLeft: '4px',
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  themeButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 16px',
    fontSize: '12px',
    fontFamily: 'var(--font-mono)',
    color: 'var(--text)',
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: '999px',
    cursor: 'pointer',
    transition: 'background 0.15s, color 0.15s, border-color 0.15s, box-shadow 0.15s',
    boxShadow: '0 10px 30px rgba(15, 23, 42, 0.07)',
  },
  statusDot: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '11px',
    color: 'var(--text-muted)',
    letterSpacing: '0.04em',
    background: 'var(--surface2)',
    border: '1px solid var(--border)',
    borderRadius: '999px',
    padding: '10px 14px',
    boxShadow: '0 10px 24px rgba(15, 23, 42, 0.06)',
  },
  dot: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    background: 'var(--success)',
    animation: 'pulse-ring 2s infinite',
  },
};

export default function Header({ theme, onToggleTheme }) {
  return (
    <header style={styles.header}>
      <Link to="/" style={{ textDecoration: 'none' }}>
        <div className="site-logo" style={styles.logo}>
          <img src="/logo.png" alt="Convert All Docs" style={styles.logoImg} />
          <span className="logo-text">Convert All Docs</span>
          <span style={styles.logoTag}>v2.0.1</span>
        </div>
      </Link>
      <div style={styles.nav}>
        <button
          type="button"
          className="theme-toggle"
          style={styles.themeButton}
          onClick={onToggleTheme}
        >
          {theme === 'dark' ? '☀️' : '🌙'}
          <span className="nav-text">{theme === 'dark' ? ' Light' : ' Dark'}</span>
        </button>
        <div className="status-badge" style={styles.statusDot}>
          <div style={styles.dot} />
          <span className="nav-text">All systems operational</span>
        </div>
      </div>
    </header>
  );
}
